<script setup>
import {onMounted, ref, watch} from "vue";
import arrayRemove from "../../lib/utils/arrayRemove.js";
import {eachDayOfInterval, endOfWeek, format, set, setDefaultOptions, startOfWeek} from "date-fns";
import {fr} from 'date-fns/locale';
setDefaultOptions( {locale: fr, weekStartsOn: 1} );

const emit = defineEmits(['step', 'change']);
const {value, pass, courses, special, times} = defineProps(['value', 'pass', 'courses', 'special', 'times']);

const selected_courses = ref( value.map( course => course.id ) ),
      selected_price = ref( 0 ),
      current_date = ref( set( new Date, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 } ) ),
      start = startOfWeek( current_date.value ),
      end = endOfWeek( current_date.value ),
      days = eachDayOfInterval( { start, end } );

onMounted( () => definePrice() );

function selectCourse(course) {
    if ( selected_courses.value.includes( course.id ) ) {
        selected_courses.value = arrayRemove( selected_courses.value, course.id );

        definePrice();
    } else if ( selected_courses.value.length < times.dance ) {
        selected_courses.value.push( course.id );

        definePrice();
    }
}

function definePrice() {
    if ( ! special ) {
        selected_price.value = pass.find( item => item.times === Math.max( 1, selected_courses.value.length ) ).price;
    }
}

function reset() {
    selected_courses.value = [];
    selected_price.value = pass.find( item => item.times === Math.max( 1, selected_courses.value.length ) ).price;
}

function next() {
    emit('change', selected_courses.value );
    emit('step', 'account');
}
</script>

<template>
    <div class="flex flex-col">
        <div class="flex flex-col lg:flex-row mb-10">
            <div class="mb-10 lg:mb-0">
                <button class="button-invert px-5 py-2" type="button" @click="emit('step', 'previous')"><i class="fa-solid fa-angle-left | mr-2"></i> Retour</button>
            </div>
            <h2 class="text-white text-4xl text-center lg:w-10/12">Choix des cours</h2>
        </div>

        <div class="flex flex-col mb-5">
            <div class="text-xl text-center text-white mb-5">Quels cours de danse chaque semaine</div>
        </div>

        <div class="flex flex-col lg:flex-row w-full gap-x-2 mb-10">
            <div v-for="(date, i) in days" :key="i"
                 class="flex flex-col w-full"
                 :class="{
                    'hidden': courses[ i ] === undefined
                 }"
            >
                <div class="bg-purple border-b-2 text-center text-white content-center uppercase p-4 mb-5">
                    <span>{{ format( date, 'eeee' ) }}</span>
                </div>

                <div v-for="(course, index) in courses[ i ]" :key="index">
                    <div
                        @click="() => selectCourse( course )"
                        class="text-white text-center p-2 2xl:px-4 mb-2 cursor-pointer transition-all border border-transparent"
                        :class="{
                            'bg-dance/40 border-white/50': course.course_type === 'dance' && selected_courses.includes( course.id ),
                            'bg-fitness/40 border-white/50': course.course_type === 'fitness' && selected_courses.includes( course.id ),
                            'bg-dance hover:border-white': course.course_type === 'dance' && ! ( selected_courses.includes( course.id ) ),
                            'bg-fitness hover:border-white': course.course_type === 'fitness' && ! ( selected_courses.includes( course.id ) ),
                        }">
                        <span class="text-xs">{{ course.schedule_start }} - {{ course.schedule_end }}</span>
                        <p class="font-bold uppercase">{{ course.title }}</p>
                        <p class="text-xs" v-if="! course.is_full">{{ course.nbr_places_try - course.count_places }} places</p>
                        <p class="text-xs" v-else>Complet</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-white text-xl font-bold text-center mb-10" v-if="special">
            {{ Math.max( times.dance, selected_courses.length ) }} séance{{ times.dance > 1 ? 's' : '' }} / semaine<br/>
        </div>

        <div class="text-white text-xl font-bold text-center mb-10" v-if="! special">
            {{ Math.max( 1, selected_courses.length ) }} séance{{ selected_courses.length > 1 ? 's' : '' }} / semaine<br/>
            {{ selected_price }} &euro; / SAISON
        </div>

        <div class="text-center flex flex-row gap-x-5 justify-center">
            <button class="button-text | px-5 py-3" type="button" :disabled="selected_courses.length === 0"
                    @click="reset" name="Réinitialiser">Réinitialiser <i class="fa-solid fa-rotate-left | ml-2"></i></button>

            <button class="button | px-5 py-3" type="button" :disabled="selected_courses.length === 0 || (special && selected_courses.length < times.dance)"
                    @click="next" name="Suivant">Suivant <i class="fa-solid fa-angle-right | ml-2"></i></button>
        </div>
    </div>
</template>